<template>
  <div>
    <fin-my-profile-block title="Rechtliche Informationen">

      <ul>
        <li v-for="(item, index) in routes" :key="index">
          <router-link :to="item.to">{{ item.name }}</router-link>
        </li>
        <li v-if="!isApp">
          <a href="javascript: window.Cookiebot.renew()">Privacy Einstellungen</a>
        </li>
      </ul>

      <p class="footer-copyright my-12"
         v-html="copyright"/>
    </fin-my-profile-block>

  </div>
</template>

<script>
import FinMyProfileBlock from "@/components/pages/profile/MyProfileBlock"
import {COPYRIGHT} from '@/js/finConstants'
import finBrowser from "@/js/finBrowser"

export default {
  name: "FinLegalInformation",
  components: {FinMyProfileBlock},
  data: () => ({
    isApp: finBrowser.IS_IOS_OR_ANDROID_APP,
    copyright: COPYRIGHT,
    routes: [
      {to: {name: 'imprintProtected'}, name: 'Impressum'},
      {to: {name: 'dataProtectionProtected'}, name: 'Datenschutz'},
      {to: {name: 'finAgb'}, name: 'AGB'},
      {to: {name: 'riskWarningsProtected'}, name: 'Risikohinweise'}
    ],
  })
}
</script>

<style lang="scss" scoped>
a {
  color: #02073a !important;
  text-decoration: none;
}

.footer-copyright {
  font-weight: bold;
  font-size: 13px;
}
</style>
